import React, { useState, useEffect } from 'react';
import { FaRupeeSign } from "react-icons/fa";

const UPIPay = () => {
  const [amount, setAmount] = useState('');
  const [qrData, setQrData] = useState('');

  const UpiID = "teleroidgroup@axl";
  const RecipientName = "Abhishek";

  useEffect(() => {
    if (amount) {
      const sanitizedAmount = parseFloat(amount);
      if (!isNaN(sanitizedAmount) && sanitizedAmount > 0) {
        const upiURL = `upi://pay?pa=${UpiID}&am=${sanitizedAmount}&pn=${RecipientName}`;
        setQrData(upiURL);
      } else {
        setQrData('');
      }
    } else {
      setQrData('');
    }
  }, [amount]);

  const handlePayThroughUPI = () => {
    if (qrData) {
      window.location.href = qrData;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-black p-4">
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 p-6 rounded-2xl shadow-xl w-full max-w-md text-white">
        <h1 className="text-3xl font-bold text-center mb-4 text-indigo-400">UPI QR Pay</h1>
        <p className="text-center text-gray-400 mb-6">Generate a UPI QR Code & Pay Instantly</p>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-400 mb-2">Enter Amount</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
              <FaRupeeSign className="text-gray-500" />
            </div>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="block w-full pl-10 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-lg shadow-inner text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="Enter Amount"
            />
          </div>
        </div>

        {qrData && (
          <div className="flex flex-col items-center">
            <div className="bg-white p-4 rounded-2xl shadow-md">
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrData)}`}
                alt="QR Code"
                className="w-48 h-48 rounded-lg"
              />
              <h2 className="text-lg font-semibold text-center mt-2 text-gray-800">Amount: ₹{amount}</h2>
            </div>
            <p className="text-sm text-gray-400 mt-2">Scan & Pay using any UPI App</p>
            <button
              onClick={handlePayThroughUPI}
              className="mt-4 w-full bg-indigo-500 text-white py-3 px-6 rounded-lg hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition duration-300 shadow-lg"
            >
              Pay via UPI App
            </button>
          </div>
        )}

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-400">
            Need a custom UPI URL for YourSelf !?  
            <a 
            // href="/create-upi" 
            href="/coming"
            className="text-indigo-400 hover:text-indigo-500 underline ml-1">
              Click here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UPIPay;
